<template>
  <div class="user_registration_div">
    <!-- Include the Language Switcher component -->
    <LanguageSwitcher />

    <v-btn class="tech_primary_button mr-4" variant="flat" color="primary" :to=loginRoute :ripple="true" size="large">log in</v-btn>
    <v-btn class="tech_action_button" variant="flat" color="action" to="register" :ripple="true" size="large"> Create Account </v-btn>
    <router-link class="user_registration_mobile" to="/login">
      <v-avatar :image="getResourceUrl(`/maya/icons/login-icon.png`)" size="40"></v-avatar>
      <v-tooltip activator="parent" location="bottom" class="hidden-xs">Login</v-tooltip>
    </router-link>
  </div>
</template>

<script lang="ts" setup>
import { getResourceUrl, sportTitle } from '@/services/admin_actions/apiUtils';
import { useRoute } from 'vue-router'; // Import Vue Router for routing
import { computed } from 'vue'; // Import Vue's computed function

import LanguageSwitcher from '@/components/SingleElements/LanguageSwitcher.vue';

const route = useRoute(); // Vue router route object
const loginRoute = computed(() => {
  return '/menu_login?action=logout&referer=' + route.path; // Construct the login route with the current path as a referer
});
</script>

<style lang="scss">
// Ensure the buttons are displayed in a row with a gap between them
.user_registration_div {
  display: flex;
  gap: 0px;
  align-items: center;
  justify-content: center;
  // width: 100%;
  // Media Queries for Registration Buttons on Tablet Screens
  @media only screen and (max-width: $mobile-screen) {
    .tech_action_button,
    .tech_primary_button {
      display: none;
    }
  }
}

// Ensure the buttons have equal width
.tech_primary_button,
.tech_action_button {
  flex: 1; /* Assigns equal width to both buttons */
}

// Media Queries for Navigation Component on Tablet Screens
@media only screen and (min-width: $mobile-screen) {
  // Hide the User Registration Button on Tablet screens
  .user_registration_mobile {
    display: none;
  }
}
</style>
